import { colors, font, spacing } from '@chegg-ui/theme';
import { ChevronIcon } from '@chegg-ui/horizon-icons';
import styled, { css } from 'styled-components';
export var AccordionHeading = styled.h2.withConfig({
  componentId: "v1s7mf-0"
})(["", " position:relative;padding-bottom:", ";"], function (_ref) {
  var size = _ref.size;
  return size === 'xl' ? "min-height: 26px;" : "margin:0; min-height: 2.5rem;";
}, function (_ref2) {
  var size = _ref2.size,
      customTheme = _ref2.customTheme;
  return customTheme[size].headingPaddingBottom;
});
export var AccordionControl = styled.button.withConfig({
  componentId: "v1s7mf-1"
})(["position:absolute;height:", ";width:100%;background-color:", ";color:inherit;line-height:", ";", " margin:0;padding:0;padding-left:", ";padding-right:", ";font-size:", ";font-weight:", ";font-family:", ";display:flex;align-items:center;justify-content:space-between;&:hover{background-color:", ";}", " ", ""], function (_ref3) {
  var size = _ref3.size,
      customTheme = _ref3.customTheme;
  return customTheme[size].height;
}, colors.white, function (_ref4) {
  var customTheme = _ref4.customTheme;
  return customTheme.lineHeight;
}, function (_ref5) {
  var size = _ref5.size;
  return size === 'xl' ? "border-radius: 16px 16px 0 0; border: 1px solid #CDCDD4;" : "border: 0;";
}, function (_ref6) {
  var size = _ref6.size,
      customTheme = _ref6.customTheme;
  return customTheme[size].paddingLeft;
}, function (_ref7) {
  var size = _ref7.size,
      customTheme = _ref7.customTheme;
  return customTheme[size].paddingRight;
}, function (_ref8) {
  var size = _ref8.size,
      customTheme = _ref8.customTheme;
  return customTheme[size].labelFontSize;
}, function (_ref9) {
  var customTheme = _ref9.customTheme,
      size = _ref9.size;
  return customTheme[size].labelFontWeight;
}, font.family["default"], function (_ref10) {
  var customTheme = _ref10.customTheme;
  return customTheme.hoverBackgroundColor;
}, function (_ref11) {
  var nested = _ref11.nested,
      customTheme = _ref11.customTheme;
  return nested ? css(["background-color:", ";&:hover,&:focus{background-color:", ";}"], customTheme.nestedBackgroundColor, customTheme.nestedHoverBackgroundColor) : '';
}, function (_ref12) {
  var isActive = _ref12.isActive,
      size = _ref12.size,
      customTheme = _ref12.customTheme;
  return isActive ? size === 'xl' ? "border-radius: 16px 16px 0 0;" : '' : size === 'xl' ? "border-radius: 16px; border-bottom: 1px solid #CDCDD4;box-shadow: ".concat(customTheme[size].boxShadow, ";") : "border-bottom: 1px solid ".concat(colors.greyLight, ";");
});
export var AccordionContainer = styled.div.withConfig({
  componentId: "v1s7mf-2"
})(["width:100%;font-family:", ";", " ", ""], font.family["default"], function (_ref13) {
  var hideFocusOutlineStyle = _ref13.hideFocusOutlineStyle;
  return hideFocusOutlineStyle ? "\n    outline: none;\n    & * {\n      outline: none;\n    }\n" : '';
}, function (_ref14) {
  var nested = _ref14.nested;
  return nested ? css(["background-color:", ";margin:", " ", ";width:calc(100% - ", ");"], colors.royalXlight, spacing.px16, spacing.px32, spacing.px64) : '';
});
export var SpacedChevron = styled(ChevronIcon).withConfig({
  componentId: "v1s7mf-3"
})(["margin-left:", ";"], function (_ref15) {
  var size = _ref15.size,
      $customTheme = _ref15.$customTheme;
  return size === 'medium' ? $customTheme['xl'].chevronIconMarginLeft : $customTheme['md'].chevronIconMarginLeft;
});
export var AccordionPanel = styled.div.withConfig({
  componentId: "v1s7mf-4"
})(["display:none;", " ", ""], function (_ref16) {
  var isActive = _ref16.isActive,
      size = _ref16.size,
      customTheme = _ref16.customTheme;
  return isActive ? size === 'xl' ? "\n      display: block;\n      border: 1px solid #CDCDD4;\n      border-radius: 0 0 16px 16px;\n      padding-top: 2rem;\n      box-shadow: ".concat(customTheme[size].boxShadow, ";\n      ") : "display: block; border-bottom: 1px solid ".concat(colors.greyLight, ";") : '';
}, function (_ref17) {
  var nested = _ref17.nested;
  return nested ? css(["background-color:", ";"], colors.white) : '';
});
export var AccordionTabHeader = styled.div.withConfig({
  componentId: "v1s7mf-5"
})(["margin-top:", ";text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:80%;text-align:initial;"], function (_ref18) {
  var size = _ref18.size,
      customTheme = _ref18.customTheme,
      nested = _ref18.nested;
  return nested ? customTheme.nestedHeadingMarginTop : customTheme[size].headingMarginTop;
});
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        chevronIconColor: theme.colors.border.dark900,
        hoverBackgroundColor: theme.colors.border.light100,
        nestedBackgroundColor: colors.orange100,
        nestedHoverBackgroundColor: colors.orange200,
        lineHeight: '1.3',
        nestedHeadingMarginTop: '2px',
        md: {
          height: theme.spacing.xl2,
          labelFontSize: theme.font.size.sm,
          headingPaddingBottom: '0',
          paddingRight: theme.spacing.md,
          paddingLeft: theme.spacing.md,
          chevronIconMarginLeft: theme.spacing.xs,
          boxShadow: 'none',
          labelFontWeight: theme.font.weight.medium,
          headingMarginTop: '0'
        },
        lg: {
          height: '3.5rem',
          labelFontSize: theme.font.size.sm,
          headingPaddingBottom: theme.spacing.md,
          paddingRight: theme.spacing.md,
          paddingLeft: theme.spacing.md,
          chevronIconMarginLeft: theme.spacing.xs,
          boxShadow: 'none',
          labelFontWeight: theme.font.weight.medium,
          headingMarginTop: '2px'
        },
        xl: {
          height: '5rem',
          labelFontSize: theme.font.size.lg,
          headingPaddingBottom: '0',
          paddingRight: theme.spacing.lg,
          paddingLeft: theme.spacing.xl,
          chevronIconMarginLeft: theme.spacing.md,
          boxShadow: theme.boxShadow.elevation100,
          labelFontWeight: theme.font.weight.bold,
          headingMarginTop: '0'
        }
      };
    },
    fanta: {
      chevronIconColor: colors.grey900,
      labelFontSize: font.size.px16,
      hoverBackgroundColor: colors.greyXlight,
      nestedBackgroundColor: colors.royalXlight,
      nestedHoverBackgroundColor: colors.royalLight,
      lineHeight: 'initial',
      nestedHeadingMarginTop: '0',
      md: {
        height: '100%',
        labelFontSize: font.size.px16,
        paddingRight: spacing.px8,
        paddingLeft: spacing.px16,
        chevronIconMarginLeft: spacing.px8,
        labelFontWeight: font.weight.normal,
        headingMarginTop: '0'
      }
    },
    prop: themeProp
  };
};
export var AccordionContainerTab = styled.div.withConfig({
  componentId: "v1s7mf-6"
})(["", ""], function (_ref19) {
  var size = _ref19.size;
  return size === 'xl' ? 'padding-bottom: 3rem;' : '';
});